import React, { useEffect } from 'react';
import { Button, Modal, Text } from '@goodrx/matisse';
import { LegalLink } from 'app/components/links/LegalLink/LegalLink';
import { Metric } from 'app/components/Metric';
import { trackEvent } from 'app/lib/analytics';
import { TriageBlockConfig } from '../TriageBlock';

export const code: TriageBlockConfig['code'] = 'agreeToTerms';

export const Message: TriageBlockConfig['Message'] = ({ inputValue, onSubmit, sessionId }) => {
  useEffect(() => {
    if (!inputValue) {
      trackEvent('Triage Agreement Modal Impression', { sessionId });
    }
  }, [inputValue]);

  return (
    <Modal
      title="Welcome!"
      data-qa="welcome-modal"
      open={!inputValue}
      closeOnBackdropClick={false}
      closeOnEscape={false}
      showClose={false}
      minWidth={300}>
      <Modal.Body>
        <Text as="p" mt={0}>
          To get started, I’m going to gather some information about why you&apos;re here. Although I’m not a healthcare
          provider and will not provide a medical diagnosis, I will be able to collect the information necessary to
          determine if one of our healthcare providers can assist you.
        </Text>

        <Text as="p">
          Before proceeding, if you are having a medical emergency - please stop now and call 911 or your local
          emergency number. You should also not proceed if you are pregnant or under the age of 18. By clicking &apos;I
          Agree&apos; you agree to the{' '}
          <LegalLink data-qa="terms-conditions-link" to="/legals/terms-and-conditions" target="_blank" rel="noopener">
            Terms of Use
          </LegalLink>{' '}
          and{' '}
          <LegalLink data-qa="privacy-policy-link" to="/legals/privacy-policy" target="_blank" rel="noopener">
            Privacy Policy.
          </LegalLink>
        </Text>

        <Metric name="Triage Agreement Accepted" data={{ sessionId }}>
          <Button data-qa="triage-agreement-accept-btn" block onClick={onSubmit}>
            I agree
          </Button>
        </Metric>
      </Modal.Body>
    </Modal>
  );
};

export const onSubmit: TriageBlockConfig['onSubmit'] = ({ addBlock, setCurrentInputValue }) => {
  setCurrentInputValue('I Agree');
  addBlock('chiefComplaint');
};

export const Response = () => null;

export const SavedResponse = () => null;
